import React, { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Box, Skeleton, Typography, useTheme } from '@mui/material';

import { styles } from './styles';
import { IStoryMessage } from '@bus/storyTeller/typedefs';
import { getDateTime } from '@helpers/getDateTime';
import FeatureStoryteller from '@components/icons/FeatureStoryteller';

type PromptListsProps = {
  message: IStoryMessage;
};

export const PromptLists: FC<PromptListsProps> = ({ message }) => {
  const theme = useTheme();

  return (
    <Box sx={[styles.promptList]}>
      {!!message.prompts.length && (
        <Box sx={styles.messageItemHeader} mb={'20px'}>
          <Box display={'flex'} alignItems={'center'} gap={'10px'}>
            <Box sx={styles.logo}>
              <FeatureStoryteller
                sx={{ fontSize: '32px' }}
                htmlColor={theme.palette.common.surface['surface 46']}
              />
            </Box>
            {message.prompts[0]?.created_at ? (
              <Typography variant={'body1'} color={'text.secondary'}>
                {getDateTime(message.prompts[0].created_at, 'HH:mm a')}
              </Typography>
            ) : (
              <Skeleton
                variant={'text'}
                sx={{
                  fontSize: '14px',
                  width: '70px',
                  lineHeight: '1.9',
                }}
              />
            )}
          </Box>
        </Box>
      )}
      {!!message.prompts.length &&
        message.prompts.map((story, index) => (
          <Box key={uuidv4()} sx={styles.list}>
            {story.prompt ? (
              <Box display={'flex'} alignItems={'baseline'}>
                <Typography
                  variant={'body1'}
                  color={'text.secondary'}
                  mr={'8px'}>
                  {index + 1}.
                </Typography>
                <Typography variant={'body1'} color={'text.secondary'}>
                  {story.prompt}
                </Typography>
              </Box>
            ) : (
              <>
                <Skeleton
                  variant={'text'}
                  sx={{
                    fontSize: '14px',
                    width: '100%',
                    height: '100px',
                    lineHeight: '1',
                    transform: 'scale(1)',
                  }}
                />
                <Skeleton
                  variant={'text'}
                  sx={{
                    mt: '20px',
                    fontSize: '14px',
                    width: '100%',
                    height: '100px',
                    lineHeight: '1',
                    transform: 'scale(1)',
                  }}
                />
              </>
            )}
          </Box>
        ))}
    </Box>
  );
};

export default PromptLists;
